import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';

import { IBlockQuote, SdBlockQuoteComponent } from '@seb/web-design-system/blockquote';
import { SdSpyTargetDirective } from '@seb/web-design-system/core';

import { blockQuoteSkeleton, TextQuoteComponentInterface } from '../../../models';
import { ConfigurationService, ImageService } from '../../../services';
import { AbstractComponent } from '../abstract-component.component';
import { WrapperComponent } from '../../../components/static/core';

@Component({
  selector: 'wc-text-quote',
  templateUrl: './text-quote.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WrapperComponent,
    SdBlockQuoteComponent,
    SdSpyTargetDirective
  ]
})
export class TextQuoteComponent extends AbstractComponent<TextQuoteComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  quote: IBlockQuote;

  constructor(
    private configService: ConfigurationService,
    private imageService: ImageService,
    private cdRef: ChangeDetectorRef
  ) {
    super();

    if (this.useLazyLoad) {
      this.quote = blockQuoteSkeleton;
    }
  }

  override mandatoryFunction = (cmp: TextQuoteComponentInterface): boolean => {
    return !!cmp.headline && !!cmp.subline;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$.subscribe((cmp) => {
        this.quote = this.toQuote(cmp, this.configService.config.components?.textQuote?.defaultPicto);
        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }

  private toQuote(component: TextQuoteComponentInterface, defaultPicto: string): IBlockQuote {
    return {
      quoteImg: component.picto?.url ? this.imageService.normalizeMedia(component.picto) : {
        url: defaultPicto
      },
      quote: component.headline,
      author: component.subline
    };
  }
}
